import * as React from 'react';
import { CLASSNAME_PREFIX as cp } from './componentConfig';
import './DocumentTypes.scss';
function DocumentTypes(_a) {
    var translate = _a.t, onDocumentChosen = _a.onDocumentChosen, documents = _a.documents, stepBack = _a.stepBack;
    var documentsMap = documents.map(function (docName) {
        return docName.split(' ').join('_');
    });
    return (React.createElement("div", { className: cp + "-component" },
        React.createElement("div", { className: cp + "-component__header" },
            React.createElement("i", { className: cp + "-component__back-btn", onClick: function () { return stepBack(); } }, translate('SELECT_DOCUMENT_BACK_BTN'))),
        React.createElement("div", { className: cp + "-component__content" },
            React.createElement("div", { className: cp + "-component__title" }, translate('SELECT_DOCUMENT_TYPE_TITLE')),
            React.createElement("div", null, documentsMap.map(function (name, index) {
                return (React.createElement("span", { className: cp + "-component__tile", onClick: function () { return onDocumentChosen(name); }, key: index },
                    React.createElement("i", { className: cp + "-component__tile__icon " + cp + "-component__tile__icon--" + name }),
                    translate(name)));
            }))),
        React.createElement("div", { className: cp + "-component__footer" })));
}
export default DocumentTypes;
//# sourceMappingURL=DocumentTypes.js.map